export default "__VITE_ASSET__BA6vFsKz__"